import axios from "axios"
import {v4 as uuidv4} from "uuid";
import store from '../store'

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_BACKURL || 'https://backend.dev.2atm.ru/', // 'http://127.0.0.1:8000/', // 'https://cashbox-lelik.dev.2atm.ru/', // 'https://cashbox.dev.2atm.ru/', //
    withCredentials: false
})

axiosInstance.interceptors.request.use(config => {
    // if(config.method ==='post') {
        //Check if config.url is present in state - get uuid from there, else - generate new one
        if (store.getters['idempotance/getRouteByUrl'](config.url)) {
            axiosInstance.defaults.headers.common['IdempotencyKey'] = store.getters['idempotance/getRouteByUrl'](config.url).uuid
        } else {
            const uuid = uuidv4()
            axiosInstance.defaults.headers.common['IdempotencyKey'] = uuid
            store.commit('idempotance/addRoute', {url: config.url, uuid: uuid })
        }
    // }

    return config
});

axiosInstance.interceptors.response.use((response) => {
    if (response.status >= 200 && response.status < 300) {
        const itemToRemoveIndex = store.getters['idempotance/getRoutes'].findIndex( item => item.uuid === response.config.headers.IdempotencyKey);
        if (itemToRemoveIndex !== -1) {
            store.commit('idempotance/removeRoute', response.config.headers.IdempotencyKey)
        }
    }
    return response;
});

export default axiosInstance;
